import { DAY_NAMES } from '../../../consts/initialValues';
import { isDefined, isObject, isUndefined } from '../../../utils/isDefined';
import Optional from '../../../utils/optional';

const mapScheduleForEdit = schedule => {
  const { action, eventSchedule, ...restSchedule } = schedule;

  const { end = {}, start = {}, daysOfWeek, endDate } = eventSchedule || {};

  const mappedRecurrence = Optional(daysOfWeek)
    .map(days =>
      DAY_NAMES.reduce((obj, day, i) => {
        return { ...obj, [`reccurence_${i}`]: days.includes(day) };
      }, {})
    )
    .or({});

  const { reccurenceEndType, reccurenceEndDate } = mapReccurenceEnd(endDate);

  return {
    ...restSchedule,
    ...action,
    ...mappedRecurrence,
    ...eventSchedule,
    reccurenceEndType,
    reccurenceEndDate,
    startDateSet: isDefined(start.date),
    endDateSet: isDefined(end.date),
    endDate: end.date,
    endTime: formatTime(end.time),
    startDate: start.date,
    startTime: formatTime(start.time)
  };
};

export default mapScheduleForEdit;

const mapReccurenceEnd = endDate => {
  let reccurenceEndType = 'NEVER';
  let reccurenceEndDate = null;

  if (isObject(endDate)) {
    reccurenceEndType = 'DATE';
    reccurenceEndDate = Optional(endDate.value)
      .map(value => Number(value))
      .or(null);
  }

  return { reccurenceEndType, reccurenceEndDate };
};

const formatTime = time => {
  if (isUndefined(time)) {
    return time;
  }
  return time - 3600000;
};
